import React from 'react';

const TermsAndConditionsEn: React.FC = () => {
    return (
        <table
            width='100%'
            cellSpacing='0'
            cellPadding='0'
            id='Table1'
            style={{ padding: '0 32px' }}
        >
            <tr>
                <td></td>
            </tr>
            <tr>
                <td colSpan={3}>&nbsp;</td>
            </tr>
            <tr>
                <td valign='top'>
                    <table>
                        <tr>
                            <td
                                className='pageTitle'
                                style={{ borderBottom: '1px solid black' }}
                            >
                                <h4>Terms and Conditions</h4>
                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                        </tr>
                        <tr>
                            <td>
                                Please read these terms carefully, and review
                                review them with the applicant, before
                                submitting an application to Volkswagen Credit.
                            </td>
                        </tr>
                        <tr>
                            <td height='14px'>&nbsp;</td>
                        </tr>
                        <tr>
                            <td>
                                <ol>
                                    <li className='bulletineitem'>
                                        {' '}
                                        Volkswagen Credit may, from time to time
                                        without advance notice, amend or revise
                                        these terms and conditions.
                                    </li>
                                    <li className='bulletineitem'>
                                        {' '}
                                        The financial services described on this
                                        site are available only in the US and
                                        may not be available in all states.
                                    </li>
                                    <li className='bulletineitem'>
                                        {' '}
                                        Eligibility for the financial services
                                        shall, except to the extent provided by
                                        law, be determined solely by Volkswagen
                                        Credit.
                                    </li>
                                    <li className='bulletineitem'>
                                        {' '}
                                        The calculations, amounts, figures,
                                        numbers and information provided at this
                                        site are estimates and are for
                                        illustrative purposes only. They do not
                                        constitute an offer and are subject to
                                        change at any time without advance
                                        notice.
                                    </li>
                                    <li className='bulletineitem'>
                                        {' '}
                                        Volkswagen Credit makes no warranties or
                                        representations as to the accuracy of
                                        the information contained on this site.
                                        By using this site, you agree that
                                        Volkswagen Credit shall have no
                                        liability (whether based upon contract,
                                        tort or otherwise) for direct, indirect,
                                        incidental, consequential or special
                                        damages arising in any way out of the
                                        use of this site.
                                    </li>
                                    <li className='bulletineitem'>
                                        {' '}
                                        Information, which you provide to
                                        Volkswagen Credit, may not be on a
                                        confidential basis. Volkswagen Credit
                                        will however use such information in a
                                        lawful manner and for any legal purpose.
                                    </li>
                                    <li className='bulletineitem'>
                                        {' '}
                                        This application is being submitted on
                                        your behalf.
                                    </li>
                                </ol>
                            </td>
                        </tr>
                        <tr>
                            <td height='14px'>&nbsp;</td>
                        </tr>
                        <tr>
                            <td>
                                <b>CALIFORNIA RESIDENTS</b>: A married applicant
                                may apply for an individual account.
                            </td>
                        </tr>
                        <tr>
                            <td height='14px'>&nbsp;</td>
                        </tr>
                        <tr>
                            <td>
                                <b>MAINE RESIDENTS</b>: Consumer reports (credit
                                reports) may be obtained in connection with this
                                application. If you request, you will be
                                informed: (1) whether or not consumer reports
                                were obtained, and (2) if reports were obtained,
                                the names and addresses of the consumer
                                reporting agencies (credit Bureaus) that
                                furnished the reports. You have the right to
                                choose the agent and insurer for the insurance
                                required by this transaction, but the insurer
                                must be approved by the creditor.
                            </td>
                        </tr>
                        <tr>
                            <td height='14px'>&nbsp;</td>
                        </tr>
                        <tr>
                            <td>
                                <b>MASSACHUSETTS RESIDENTS</b>:
                                Massachusetts&#39s law prohibits discrimination
                                on the basis of marital status or sexual
                                orientation.
                            </td>
                        </tr>
                        <tr>
                            <td height='14px'>&nbsp;</td>
                        </tr>
                        <tr>
                            <td>
                                <b>NEW YORK RESIDENTS</b>: A consumer credit
                                report may be required in connection with this
                                application or in connection with updates,
                                renewals, extensions or enforcement of any
                                credit granted as a result of this application.
                                Upon your request, you will be informed whether
                                or not a consumer credit report was requested,
                                and if so, the name and address of the agency
                                that furnished such report.
                            </td>
                        </tr>
                        <tr>
                            <td height='14px'>&nbsp;</td>
                        </tr>
                        <tr>
                            <td>
                                <b>OHIO RESIDENTS</b>: The Ohio laws against
                                discrimination require that all creditors make
                                credit equally available to all credit worthy
                                customers, and that credit reporting agencies
                                maintain separate credit histories on each
                                individual upon request The Ohio Civil Rights
                                Commission administers compliance with this law.
                            </td>
                        </tr>
                        <tr>
                            <td height='14px'>&nbsp;</td>
                        </tr>
                        <tr>
                            <td>
                                <b>RHODE ISLAND RESIDENTS</b>: A consumer credit
                                report may be requested in connection with this
                                application.
                            </td>
                        </tr>
                        <tr>
                            <td height='14px'>&nbsp;</td>
                        </tr>
                        <tr>
                            <td>
                                <b>MARRIED WISCONSIN RESIDENTS</b>: No provision
                                of a marital property agreement, a unilateral
                                settlement agreement under Wis. Stat. ยง 766.59,
                                or a court decree under Wis. Stat. ยง 766.70
                                adversely affects the interest of the creditor
                                unless the creditor, prior to the time credit is
                                granted, is furnished a copy of the agreement,
                                statement or decree, or has actual knowledge of
                                the adverse provision. If you are making this
                                application individually and not jointly with
                                your spouse, please provide the full name and
                                current address of your spouse in Section B.&#34
                            </td>
                        </tr>
                        <tr>
                            <td height='14px'>&nbsp;</td>
                        </tr>
                        <tr>
                            <td>
                                <b>Security</b>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Whenever Volkswagen Credit requests personal
                                information from you we require a secure session
                                using the SSL (Secure Socket Layer) protocol.
                                This protocol creates a secure connection using
                                a public key exchange with your computer. Once
                                the key exchange has taken place all personal
                                data being transmitted is encrypted making the
                                conversation between your computer and
                                Volkswagen Credit private. The key exchange is
                                randomly generated by the server to ensure no
                                other computer will be able to duplicate it.
                            </td>
                        </tr>
                        <tr>
                            <td height='14px'>&nbsp;</td>
                        </tr>
                        <tr>
                            <td>
                                <b>Browser support for SSL technology</b>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Only certain browsers support the SSL 128-bit
                                technology and it is in your best interest to
                                ensure you have a supported browser. SSL
                                technology is included in Microsoft Internet
                                Explorer 4.0 and higher with the 128-bit patch.
                                However, this site was designed for Microsoft
                                Internet Explorer 7.0 and higher with the
                                128-bit patch.
                            </td>
                        </tr>
                        <tr>
                            <td height='30px'>&nbsp;</td>
                        </tr>
                    </table>
                </td>
            </tr>
        </table>
    );
};

export default TermsAndConditionsEn;
